import { KTSVG } from '../../../_metronic/helpers'
import React, { FC, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useAuth } from '../../../app/modules/auth'
import { useDeletePurchaseItem } from '../../contextProviders/Atomqueryprovider'

type Props = {
  show: boolean
  handleClose: () => void
  itemtodelete: any
  statedeletingitem?: boolean
  cannotDeleteitem?: boolean
  allpurchasesrefetch?: () => void
}

const CURRENCY_APP = process.env.REACT_APP_CURRENCY

export const DeletePurchaseItem: FC<Props> = (props) => {
  const { currentUser } = useAuth()
  const [error, setError] = useState<string | null>(null)
  
  // No parameters when creating the hook
  const { mutate: deleteMutate, isLoading: isDeleting, isSuccess: deleteSuccess, isError: deleteError } = useDeletePurchaseItem()

  useEffect(() => {
    if (deleteSuccess) {
      props.allpurchasesrefetch?.()
      props.handleClose()
    }
    if (deleteError) {
      setError('Error deleting purchase item. This item cannot be deleted due to existing dependencies or transactions.')
    }
  }, [deleteSuccess, deleteError, props])

  const handleDelete = () => {
    setError(null)
    // Pass parameters when calling mutate
    deleteMutate({
      purchase_item_id: props.itemtodelete.purchase_item_id,
      user_id: Number(currentUser?.user_id)
    })
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Delete Purchase Item
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{props.itemtodelete.product_details?.product_name || 'N/A'}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row mb-7'>
            <div className='card bg-light'>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='required card-label fw-bolder fs-5 mb-1'>Item Description</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    {props.itemtodelete.product_details?.product_description || 'N/A'}
                  </span>
                </h3>
              </div>
              {/* end::Header */}
              {/* begin::Body */}
              <div className='card-body py-3 mb-5'>
                <div className='row'>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Quantity: </span>
                    {props.itemtodelete.quantity} {props.itemtodelete.product_details?.unit_name || 'UNITS'}
                  </div>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Unit Cost: </span>
                    {props.itemtodelete.unit_cost} {CURRENCY_APP}
                  </div>
                </div>
                <div className='row mt-2'>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Total Cost: </span>
                    {props.itemtodelete.total_cost} {CURRENCY_APP}
                  </div>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Received Quantity: </span>
                    {props.itemtodelete.received_quantity}
                  </div>
                </div>
                <div className='row mt-2'>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Category: </span>
                    {props.itemtodelete.product_details?.category_name || 'UNCATEGORISED'}
                  </div>
                  <div className='col-md-6'>
                    <span className='fw-bold'>Barcode: </span>
                    {props.itemtodelete.product_details?.barcode || 'N/A'}
                  </div>
                </div>
              </div>
              {/* end::Body */}
            </div>
          </div>

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above purchase item?
          </span>

          {error && (
            <div className='alert alert-danger mt-5'>
              <div className='alert-text font-weight-bold'>
                {error}
              </div>
            </div>
          )}
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {!isDeleting && <span className='indicator-label'>Delete Item</span>}
            {isDeleting && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}